var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"button",attrs:{"disabled":_vm.selectedProjects.length <= 0},on:{"click":_vm.openAssignEditorForm}},[_vm._v(" Assign Editor ")])
}
var staticRenderFns = []

export { render, staticRenderFns }